import {
  Validator,
  UntypedFormControl,
  NG_VALIDATORS,
} from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appConfirmPassword][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: RepasswordValidator, multi: true },
  ],
})
export class RepasswordValidator implements Validator {
  @Input() confirmPassword?: string;

  constructor() {}

  validate(c: UntypedFormControl) {
    const isEqual = c.value === this.confirmPassword;
    const isEmpty = c.value === null || c.value === '';
    if (isEqual || isEmpty) {
      return null;
    };
    const confirmPassword = {
      valid: false,
    };
    return {
      confirmPassword,
    };
  }
}
